import { createClient } from "@supabase/supabase-js";

// Im Image kommen die Werte zur Laufzeit aus /env.js (beim Containerstart
// geschrieben, siehe env.js.template), damit ein Image für jede Instanz taugt.
// In der Entwicklung (npm start) aus REACT_APP_SUPABASE_*.
const runtimeEnv = window.__ENV__ || {};
const supabaseUrl = runtimeEnv.SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = runtimeEnv.SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // createClient(undefined) throws anyway — but with a cryptic stack and a
  // white page. Fail loudly with the actual fix instead.
  const msg = "Konfigurationsfehler: SUPABASE_URL und SUPABASE_ANON_KEY fehlen (/env.js, in der Entwicklung REACT_APP_SUPABASE_*).";
  console.error(msg);
  document.addEventListener("DOMContentLoaded", () => {
    const el = document.getElementById("root");
    if (el && !el.hasChildNodes()) {
      el.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;min-height:100vh;color:#e5e7eb;background:#191c24;font-family:sans-serif;padding:24px;text-align:center">${msg}</div>`;
    }
  });
  throw new Error(msg);
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: "relticc-auth",
    storage: localStorage,
  },
});
